import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Cookie } from 'lucide-react';
import { Button } from './ui/button';

export const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="bg-white border-b border-gray-100">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img src="/assets/cl-heart.png" alt="Connect Legacy" className="h-14 w-14 object-contain" />
            <span className="text-xl font-bold text-gray-900">Connect Legacy</span>
          </Link>
          <Link to="/">
            <Button variant="ghost" className="text-gray-600 hover:text-[#7E33E0]">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Home
            </Button>
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 max-w-3xl">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 bg-[#7E33E0]/10 rounded-xl flex items-center justify-center">
            <Cookie className="h-6 w-6 text-[#7E33E0]" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900">Cookie Policy</h1>
        </div>

        <p className="text-sm text-gray-500 mb-10">Last updated: June 2026</p>

        <div className="space-y-6 text-gray-700 leading-relaxed">
          <p>Connect Legacy currently does not use advertising, analytics, or tracking cookies on this website.</p>

          <p>Some essential technical cookies may be used by our website hosting provider to ensure the website functions correctly and securely. These cookies do not collect personal information for marketing purposes.</p>

          <p>If our use of cookies changes in the future, this Cookie Policy will be updated accordingly.</p>

          <p className="pt-6 border-t border-gray-200 text-sm">
            If you have any questions regarding this Cookie Policy, please contact us at{' '}
            <a href="mailto:support@connect-legacy.com" className="text-[#7E33E0] hover:underline font-medium">
              support@connect-legacy.com
            </a>
          </p>
        </div>
      </main>

      <footer className="bg-gray-950 text-gray-400 py-8 px-4 mt-16">
        <div className="container mx-auto max-w-6xl text-center text-xs">
          © 2026 Connect Legacy. All rights reserved.
        </div>
      </footer>
    </div>
  );
};
